import { forwardRef } from "react";
import { FormControl, FormErrorMessage, Input } from "@chakra-ui/react";
import { getObjValueFromPath } from "utils";
import EsgFormLabel from "./EsgFormLabel";
/**
 * @param {Object?} errors - From react-hook-form formState.errors.
 * @param {string?} label 
 * @param {string} name
 * @param {string?} id
 * @param {Object} controlProps
 * @param {string} maxInlineSize
 * @param {Object?} labelProps
 * @param {*} rest - Use react-hook-form register() to create and pass in other props.
 */
function FormInput(
  { label, name, id = name, errors, controlProps, maxInlineSize, labelProps, ...rest },
  ref
) {
  const error = errors && getObjValueFromPath(name, errors);
  if ( ! maxInlineSize ) maxInlineSize = { base: "full", lg: "xs" }; // why??
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={maxInlineSize}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel htmlFor={id} {...labelProps}>
          {label}
        </EsgFormLabel>
      )}
      <Input backgroundColor="white" id={id} name={name}
	  	// borderRadius="none" see recent figma designs
		marginBlockStart={1}
        _focus={{ borderColor: "lime", boxShadow: "0 0 0 1px var(--chakra-colors-lime)" }}
        {...rest} ref={ref} />
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormInput);
